module.exports = __webpack_public_path__ + "static/media/2008 Madrid, Spain.ec73b1f7.jpg";